import { render, staticRenderFns } from "./ExtensionDetail.vue?vue&type=template&id=67df7b59&scoped=true"
import script from "./ExtensionDetail.vue?vue&type=script&lang=js"
export * from "./ExtensionDetail.vue?vue&type=script&lang=js"
import style0 from "./ExtensionDetail.vue?vue&type=style&index=0&id=67df7b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df7b59",
  null
  
)

export default component.exports